export default function debounce(func: Function, timeout = 300) {
  let timer: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]): void {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
